<ng-template #loadingGeneral>

    <mat-spinner class="center"></mat-spinner>
    <p class="center">Loading...</p>
  
  </ng-template>
  
  <ng-template #loadingItem>
    <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
  </ng-template>
  
  <div fxLayout="column">
    <ng-container *ngIf="dataSource; else loadingGeneral">

        <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

            <mat-form-field class="mb-0">
              <mat-label>Search</mat-label>
              <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
            </mat-form-field>
            <span fxFlex></span>
            <ng-container *ngIf="!embeddedLayout">
              <button  (click)="createTester()"  *awIsInAnyRole="[roles.admin, roles.customer]" mat-button color="primary">New tester</button>
            </ng-container>
        </div>

        <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>
    <table (matSortChange)="doSortUsers($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table
      matSort multiTemplateDataRows>

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{element.id}} </td>
      </ng-container>

      <!-- First Name Column -->
      <ng-container matColumnDef="firstName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>First Name</th>
        <td *matCellDef="let element" mat-cell> {{element.firstName}} </td>
      </ng-container>

      <!-- Last Name Column -->
      <ng-container matColumnDef="lastName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Last Name</th>
        <td *matCellDef="let element" mat-cell> {{element.lastName}} </td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Email</th>
        <td *matCellDef="let element" mat-cell> {{element.email}} </td>
      </ng-container>

      <!-- Phone Column -->
      <ng-container matColumnDef="phone">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Phone</th>
        <td *matCellDef="let element" mat-cell> {{element.phone}} </td>
      </ng-container>

      <!-- Company Column -->
      <ng-container matColumnDef="company">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Company</th>
        <td *matCellDef="let element" mat-cell> {{element?.company?.companyName || element?.companyName }} </td>
      </ng-container>

      <!-- Enabled Column -->
      <ng-container matColumnDef="enabled">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Enabled</th>
        <td *matCellDef="let element" mat-cell>
          <mat-icon class="correct-color" *ngIf="element.enabled">check_circle</mat-icon>
          <mat-icon class="error-color" *ngIf="!element.enabled">cancel</mat-icon>
        </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" mat-cell class="text-right">
          <button (click)="details(element)" [disabled]="disabled" mat-icon-button matTooltip="Show details">
            <mat-icon>visibility</mat-icon>
          </button>
          <ng-container *ngIf="!embeddedLayout">
            <button (click)="expandTestbeds(element)" *awIsInAnyRole="[roles.admin, roles.customer]" [disabled]="disabled" mat-icon-button matTooltip="Show Testbeds associated">
              <mat-icon>hub</mat-icon>
            </button>
          </ng-container>
          <ng-container *ngIf = "testbed">
            <button *awIsInAnyRole="[roles.admin, roles.customer]" (click)="removeTesterFromTestbed(element)" [disabled]="disabled" mat-icon-button matTooltip="Delete Tester from Testbed">
              <mat-icon>block</mat-icon>
            </button>
          </ng-container>
          <ng-container>
            <button *awIsInAnyRole="[roles.admin]" (click)="deleteUser(element)" [disabled]="disabled" mat-icon-button
                matTooltip="Delete tester">
                <mat-icon>delete</mat-icon>
            </button>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedTestbeds">
        <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-1" mat-cell>
          <div fxLayout="row">
            <h3 class="mb-0" fxFlex>Associated Testbeds</h3>
            <button (click)="expandedTestbeds = undefined" mat-button>Close</button>
          </div>
          <aw-list-testbeds *ngIf="expandedTestbeds == element" [embeddedLayout]="true"
            [tester]="element"></aw-list-testbeds>
        </td>
      </ng-container>


      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>
      <tr *matRowDef="let row; columns: ['expandedTestbeds']" [fxShow]="expandedTestbeds?.id === row.id" mat-row></tr>

      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="displayedColumns.length" class="mat-cell text-center">
          No testers found
        </td>
      </tr>

    </table>

    </ng-container>

    <mat-paginator #paginatorTesters [fxShow]="dataSource && dataSource.data.length > 10"
      [ngClass]="{'mat-elevation-z2': !embeddedLayout}" [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" class="mat-elevation-z1" showFirstLastButtons></mat-paginator>
  </div>